import STATUS from '@/store/status';

// eslint-disable-next-line import/prefer-default-export
export const withUserLoaded = (action) => {
  return async function (context, payload) {
    const { rootState, dispatch } = context;

    if (rootState.user.status === STATUS.NOT_LOADED) {
      await dispatch('user/LOAD', null, { root: true });
    } else if (rootState.user.status === STATUS.LOADING) {
      await rootState.user.operation;
    }
    if (rootState.user.status !== STATUS.LOADED) return null;
    return action(context, payload);
  };
};
